// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1cjhX","header":"header-3M4OS"};